export default __webpack_public_path__ + "static/hq1-b4885d9cbc31811563cfb6d7c31816a8.jpg";